<div class="installation-tabs">
  <app-tabs-with-sections [tabs]="tabs" />
</div>

